<template>
  <div class="login">
    <canvas width="2608" height="857"></canvas>
    <div class="show-error">
      <p>账号或者密码不能为空</p>
      <p>username and password must be filled</p>
    </div>
    <div class="content">
      <div class="login-table">
        <div>
          <span>用户名</span>
          <input type="text" v-model="loginForm.username" @keyup.enter="submit" />
        </div>
        <div>
          <span>密码</span>
          <input type="password" v-model="loginForm.password" @keyup.enter="submit" />
        </div>
        <button @click="submit">登陆</button>
      </div>
    </div>
  </div>
</template>

<script>
import {getToken,loginInfo} from "../api/user.js";
import { encryption } from "../assets/api/request.js";
export default {
  data() {
    return {
     isSpinShow: false,
      loginForm: {
        username: "",
        password: "",
        code: "",
        randomStr: "",
        grant_type: "password",
        scope: "server"
      }
    };
  },
  mounted() {
    this.bg();
  },
  methods: {
    // canvas动画特效
    bg() {
      const canvas = document.querySelector("canvas");
      const ctx = canvas.getContext("2d");

      const RESOLUTION = 1;

      let w = (canvas.width = (window.innerWidth - 100) * RESOLUTION);
      let h = (canvas.height = (window.innerHeight - 20) * RESOLUTION);

      const PARTICLE_COUNT = 400;
      const CONNECT_DISTANCE = w * 0.05;
      const FORCE_DISTANCE = w * 0.1;

      const r = (n = 1) => Math.random() * n;
      const PI = Math.PI;
      const TAU = PI * 2;

      let time = new Date();

      const lerp = (start, end, amt) => {
        return (1 - amt) * start + amt * end;
      };

      const distance = (x1, y1, x2, y2) => {
        const a = x1 - x2;
        const b = y1 - y2;
        return Math.sqrt(a * a + b * b);
      };

      const angle = (cx, cy, ex, ey) => {
        return Math.atan2(ey - cy, ex - cx);
      };

      const particlePrototype = () => ({
        x: w * 0.5 + Math.cos(r(TAU)) * r(w * 0.5),
        y: h * 0.5 + Math.sin(r(TAU)) * r(h * 0.5),
        angle: r(TAU),
        speed: r(0.15),
        normalSpeed: r(0.15),
        oscAmplitudeX: r(2),
        oscSpeedX: 0.001 + r(0.008),
        oscAmplitudeY: r(2),
        oscSpeedY: 0.001 + r(0.008),
        connectDistance: r(CONNECT_DISTANCE),
        color: {
          r: 52,
          g: 109,
          b: 111
        }
      });

      const particles = new Array(PARTICLE_COUNT)
        .fill({})
        .map(particlePrototype);

      const update = () => {
        particles.forEach(p1 => {
          p1.x +=
            (Math.cos(p1.angle) +
              Math.cos(time * p1.oscSpeedX) * p1.oscAmplitudeX) *
            p1.speed;
          p1.y +=
            (Math.sin(p1.angle) +
              Math.cos(time * p1.oscSpeedY) * p1.oscAmplitudeY) *
            p1.speed;

          p1.speed = lerp(p1.speed, p1.normalSpeed * RESOLUTION, 0.1);

          if (p1.x > w || p1.x < 0) {
            p1.angle = PI - p1.angle;
          }
          if (p1.y > h || p1.y < 0) {
            p1.angle = -p1.angle;
          }

          if (r() < 0.005) p1.oscAmplitudeX = r(2);
          if (r() < 0.005) p1.oscSpeedX = 0.001 + r(0.008);
          if (r() < 0.005) p1.oscAmplitudeY = r(2);
          if (r() < 0.005) p1.oscSpeedY = 0.001 + r(0.008);

          p1.x = Math.max(-0.01, Math.min(p1.x, w + 0.01));
          p1.y = Math.max(-0.01, Math.min(p1.y, h + 0.01));
        });
      };

      const render = () => {
        ctx.clearRect(0, 0, w, h);

        particles.map(p1 => {
          particles
            .filter(p2 => {
              if (p1 == p2) return false;
              if (distance(p1.x, p1.y, p2.x, p2.y) > p1.connectDistance)
                return false;
              return true;
            })
            .map(p2 => {
              const dist = distance(p1.x, p1.y, p2.x, p2.y);
              p1.speed = lerp(
                p1.speed,
                p1.speed + (0.05 / p1.connectDistance) * dist,
                0.2
              );
              return {
                p1,
                p2,
                color: p1.color,
                opacity:
                  Math.floor(
                    (100 / p1.connectDistance) * (p1.connectDistance - dist)
                  ) / 100
              };
            })
            .forEach((line, i) => {
              const colorSwing = Math.sin(time * line.p1.oscSpeedX);
              ctx.beginPath();
              ctx.globalAlpha = line.opacity;
              ctx.moveTo(line.p1.x, line.p1.y);
              ctx.lineTo(line.p2.x, line.p2.y);
              ctx.strokeStyle = `rgb(52, 109, 111)`;
              ctx.lineWidth = line.opacity * 4;
              ctx.stroke();
              ctx.closePath();
            });
        });
      };

      const loop = () => {
        time = new Date();
        update();
        render();
        window.requestAnimationFrame(loop);
      };

      loop();

      window.addEventListener("mousemove", e => {
        const mouseX = e.layerX * RESOLUTION;
        const mouseY = e.layerY * RESOLUTION;

        particles.forEach(p => {
          const dist = distance(mouseX, mouseY, p.x, p.y);

          if (dist < FORCE_DISTANCE && dist > 0) {
            p.angle = angle(mouseX, mouseY, p.x, p.y);
            const force = (FORCE_DISTANCE - dist) * 0.1;
            p.speed = lerp(p.speed, force, 0.2);
          }
        });
      });

      window.addEventListener("resize", e => {
        w = canvas.width = window.innerWidth * RESOLUTION;
        h = canvas.height = window.innerHeight * RESOLUTION;
      });
    },
    // 提交表单
    submit() {
      if (!this.loginForm.username && !this.loginForm.password) {
		this.$notify.warning({
		    title: '提示',
		    message: '用户名，密码不能为空！'
		});
      } else {
        const user = encryption({
          data: this.loginForm,
          key: "thanks,pig4cloud",
          param: ["password"]
        });
        getToken(user)
          .then(res => {
          console.log(res);
            localStorage.setItem("access_token", res.access_token);
            localStorage.setItem("refresh_token", res.refresh_token);
            localStorage.setItem("token_type", res.token_type);
			loginInfo()
              .then(res => {
                  if (res.code == 0) {
                    if (!res.data.org) {
					  this.$notify.error({
					      title: '错误',
					      message: '登录失败，请确认您的账号为政府帐号！'
					  });
                    } else {
					  this.$notify.success({
					      title: '成功',
					      message: '登录成功！',
						  duration:2000 
					  });
					  localStorage.setItem(
					    "loginUserInfo",
					    JSON.stringify(res.data)
					  );
					  setTimeout(() =>{
						this.$router.push("/home");  
					  },2100);
                    }
                  } else {
					this.$notify.error({
					    title: '错误',
					    message: res.msg
					});
                  }
              })
              .catch(err => {
				this.isSpinShow = false;
				this.$notify.error({
					title:'错误',
					message:'网络错误，请稍候再试!'
				});
              });
        })
        .catch(err => {
          this.isSpinShow = false;
		  this.$notify.error({
		  	title:'错误',
		  	message:'用户名不存在或密码错误!'
		  });
        });
        // let userName = 'fuhong';
        // let password = '123';
        // if(this.password != password || this.userName != userName) {
        //     alert('账号或者密码错误')
        // }else {
        //     window.localStorage.setItem('isLogined',true);
        //     this.$router.replace('/home')
        // }
      }
    }
  }
};
</script>

<style lang='less'>
.login {
  position: absolute;
  width: 100%;
  z-index: 999;
  .content {
    position: absolute;
    width: 600px;
    height: 400px;
    top: 200px;
    left: calc(50% - 300px);
    .login-table {
      overflow: hidden;
      border: 2px solid rgb(52, 109, 111);
      box-shadow: inset 0px 0px 10px #346d6f, 0px 0px 50px #346d6f,
        0px 0px 50px #6ab7b9;
      position: absolute;
      width: 367px;
      height: 230px;
      left: calc(50% - 204px);
      margin: 40px auto 0;
      margin-left: 20px;
      background-image: url("../assets/images/right-div-ch.png");
      background-size: 100% 100%;
      background-position: center;
      text-align: center;
      line-height: 100px;
      animation: openLogin 0.6s linear;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      div {
        color: #6ab7b9;
        height: 50px;
        width: 240px;
        display: flex;
        justify-content: space-between;
        line-height: 50px;
        align-items: center;
        position: relative;
        input {
          width: 240px;
          height: 20px;
          vertical-align: 20px;
          background: none;
          padding: 4px 0 4px 60px;
          outline: none;
          color: hsl(155, 25%, 55%);
          background-color: #132229;
          border: none;
          border: 1px solid #487577;
        }
        span {
          position: absolute;
          display: block;
          width: 48px;
          height: 32px;
          text-align: left;
          line-height: 32px;
          left: 6px;
        }
      }
      button {
        width: 240px;
        border: none;
        background-color: #6ab7b9;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        color: #1a2a31;
        cursor: pointer;
        outline: none;
      }
    }
    @keyframes openLogin {
      0% {
        width: 0px;
      }
      10% {
        width: 36px;
      }
      20% {
        width: 72px;
      }
      30% {
        width: 108px;
      }
      40% {
        width: 144px;
      }
      50% {
        width: 180px;
      }
      60% {
        width: 216px;
      }
      70% {
        width: 252px;
      }
      80% {
        width: 288px;
      }
      90% {
        width: 324px;
      }
      100% {
        width: 367px;
      }
    }
  }
}
.show-error {
  position: absolute;
  width: 400px;
  height: 100px;
  background-color: darkcyan;
  right: 0;
  top: 100px;
  text-align: center;
  line-height: 40px;
  display: none;
}
</style>